import React, { Fragment, useEffect, useState } from 'react'
import { getValueFromResource } from '../../../common/timeLiveFunction';
import { KTSVG } from '../../../_metronic/helpers';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { Formik } from 'formik';
import fetchTimeliveAPI from '../../../common/fetchTimeliveAPI';
import { ShowToast } from '../../../common/Toastr';
import { getAccountGeoFenceZoneType, getAccountGeoFenceZoneTypeById } from './GeofencingSlice';
import Loader from '../../../common/Loader';

interface ZoneTypeClass {
    ZoneType: string
    IsDisable: boolean
}

const ZoneTypeForm = (props: any) => {
    const { oncloseModal, id } = props
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { isLoading } = useAppSelector((state) => state.geofencing);
    const [formData, setFormData] = useState<ZoneTypeClass>({
        ZoneType: '',
        IsDisable: false
    });

    const getZoneTypeById = async () => {
        try {
            const response = await dispatch(getAccountGeoFenceZoneTypeById(id));
            if (response?.meta?.requestStatus === 'fulfilled') {
                const data = response?.payload?.Data[0];
                setFormData({
                    ZoneType: data.ZoneTypeName ?? '',
                    IsDisable: data.IsDisabled ?? false
                });
                console.log(response, "responseeeee")
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (id) {
            getZoneTypeById();
        } else {
            setFormData({
                ZoneType: '',
                IsDisable: false
            });
        }
    }, [id])

    const handleSubmit = async (values: any, action: any) => {
        const payload = {
            ZoneTypeName: values?.ZoneType,
        }
        let response: any;
        try {
            if (id) {
                const updatePayload = {
                    ZoneTypeName: values?.ZoneType,
                    IsDisabled: values?.IsDisable,
                    AccountGeoFenceZoneTypeId: id
                }
                response = await fetchTimeliveAPI(`api/GeoFenceZoneType/UpdateAccountGeoFenceZoneType/${id}`, 'PUT', updatePayload, true);
            } else {
                response = await fetchTimeliveAPI('api/GeoFenceZoneType', 'POST', payload, true);
            }
            const json = await response.json();
            if (json?.StatusCode === '200' || json?.StatusCode == '201') {
                ShowToast('Success', json.ResponseMessage, "success", "toast-top-right");
                dispatch(getAccountGeoFenceZoneType())
                action.resetForm();
                oncloseModal();
            } else {
                ShowToast('error', json.ResponseMessage, "error", "toast-top-right")
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <>
            {isLoading && <Loader />}
            <Formik
                initialValues={formData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values, action); }}
                validationSchema={yup.object().shape({
                    ZoneType: yup
                        .string()
                        .label('ZoneType')
                        .trim()
                        .required(t('Zone type is required'))
                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form>
                            <div className='card-body'>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    :
                                    <>
                                        <div className="modal drawer-overlay" style={{ display: 'block' }}
                                        >
                                            <div className="modal-dialog">
                                                <div className="modal-content">
                                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                        <h5 className="modal-title mainHeading">
                                                            {id ?
                                                                getValueFromResource('Update ', dispatch, t)
                                                                :
                                                                getValueFromResource('Add ', dispatch, t)}

                                                            {getValueFromResource('Zone Type', dispatch, t)}
                                                        </h5>

                                                        <div
                                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                            onClick={oncloseModal}
                                                        >
                                                            <KTSVG
                                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                                className="svg-icon svg-icon-1x"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="modal-body">
                                                        <form className='form'>
                                                            <div className="mb-0">
                                                                <label className="fs-7 fs-7 fw-normal">
                                                                    {getValueFromResource('Zone Type', dispatch, t)}
                                                                </label>
                                                                <input type="text" className="form-control fs-7 fw-normal mt-2" id='ZoneType' value={values.ZoneType} name='ZoneType'
                                                                    onChange={handleChange('ZoneType')}
                                                                    style={{ color: '#172b4d' }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('ZoneType', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ paddingRight: 5, paddingBottom: 5 }}>
                                                                {touched.ZoneType && errors.ZoneType &&
                                                                    <p className='errorMsg'>{errors.ZoneType as string}</p>
                                                                }
                                                            </div>
                                                            {id && <div className="mb-3" >
                                                                <label className="fs-7 fw-normal mt-2">
                                                                    {getValueFromResource('Disabled', dispatch, t)}

                                                                </label>
                                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                    <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisable} id="IsDisable"
                                                                        onChange={handleChange('IsDisable')}
                                                                    />
                                                                </div>
                                                            </div>}
                                                        </form>
                                                    </div>
                                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                            onClick={oncloseModal}
                                                        >
                                                            {getValueFromResource('Cancel', dispatch, t)}
                                                        </button>
                                                        <button type="button" className="btn btn-primary btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()}>
                                                            {getValueFromResource('Save', dispatch, t)}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </form>
                    </Fragment>
                )}
            </Formik>
        </>
    )
}

export default ZoneTypeForm